import React from 'react';
import './Perks.css';

/* //testing data
const mockData = [{
  headline: 'Lorem Ipsum',
  description: 'Lorem ipsum dolor sit amet consectetur adipiscing elit curae',
  perkCopy: ['Lorem Uipsum dolor sit a', 'tetur adipiscing elit curae'],
}, {
  headline: 'Lorem Ipsum',
  description: 'Lorem ipsum dolor sit amet consectetur adipiscing elit curae',
  perkCopy: ['Lorem Uipsum dolor sit a', 'tetur adipiscing elit curae'],
}, {
  headline: 'Lorem Ipsum',
  description: 'Lorem ipsum dolor sit amet consectetur adipiscing elit curae',
  perkCopy: ['Lorem Uipsum dolor sit a', 'tetur adipiscing elit curae'],
}];
<ul className="perkDescriptionList">
  {item.subDescription.map((text, i) => {
    return <li key={i}><span className="perkDescription">{text}</span></li>;
  })}
</ul>
*/
const cleanupSubDescription = (subDescription) => subDescription.split(/\|\|/).filter((n) => n);

export const Perks = ({ source }) => {
  const onlyOnePerk = source.length === 1 ? 'onlyOnePerk' : '';
  return (
    <div className={`perksList ${onlyOnePerk}`}>
      <div className="perksListContainer">
        {source.map((item, index) => {
          const listItems =
            item.subDescription && item.subDescription.length > 0 ? cleanupSubDescription(item.subDescription) : null;
          return (
            <div className="Perk" key={index}>
              <div className="perkTitle">{item.headline}</div>
              <div className="perkSubTitle">{item.description}</div>
              <div className="perkRule" />
              {listItems && (
                <ul className="perkDescriptionList">
                  {listItems.map((listItem, idx) => (
                    <li key={idx}>{listItem}</li>
                  ))}
                </ul>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};
